import loadable from '@loadable/component';

export const PricePage = loadable(/* #__LOADABLE__ */ () => import('./PricePage'));
